import Vue from 'vue'
import Component from 'vue-class-component'
import CLogo from '@/components/CLogo/CLogo.vue'

@Component({
  components: { CLogo }
})
export default class CAppHeader extends Vue {
  get isHomePage(): boolean {
    return this.$route && this.$route.name === 'home'
  }
}
